export const REGEX_POSITIVE_FLOAT = /^(?:\d+(?:\.\d+)?|)$/
